// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"relation"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3.97266 20.5876L14.1274 2.99902M20.0273 20.5876L9.87256 2.99902M2 18H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const RelationIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'relation',
    ref,
    icon: element,
  },
));

RelationIcon.displayName = 'RelationIcon';

export default RelationIcon;
